import { Component, Inject, Input } from '@angular/core';
import { Contract } from 'src/app/contract-flow/models/contract.model';
import { SuccessPageType } from 'src/app/@core/enums/success-page-type.enum';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss'],
})
export class SuccessPageComponent {
  @Input() successType!: SuccessPageType;
  @Input() contract!: Contract;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public redirect() {
    this.document.location.href = environment.loginUrl;
  }
}
